<div style="align-items: center">
  <div id="tabCambiarUsuario">
    <div class="col-login">
      <div class="loginInputWrap" [formGroup]="loginForm" style="margin-top: 65px;">
        <div class="tituloInt">Acceso agenda</div>
        <p *ngIf="error" style="color: red">{{ error }}</p>
        <div class="form-group login">
          <div class="tit-form-group">
            <label for="usuario">{{ 'USUARIO' | translate }}</label>
          </div>
          <input
            formControlName="usuario"
            #usuario
            type="text"
            class="form-control"
            id="usuario"
            category="ALFANUMERICO"
            [ngClass]="{ 'active-form': isSelected(usuario) }"
            (focus)="focusValue($event)"
          />
        </div>
        <div class="form-group login">
          <div class="tit-form-group">
            <label for="contrasena">{{ 'CONTRASENA' | translate }}</label>
          </div>
          <input
            formControlName="contrasena"
            #clave
            category="pago"
            type="password"
            class="form-control"
            id="contrasena"
            category="ALFANUMERICO"
            [ngClass]="{ 'active-form': isSelected(clave) }"
            (focus)="focusValue($event)"
          />
        </div>
        <a
          class="GestionarButton aceptar"
          [ngClass]="{ disabled: checkLoginIsInvalid() }"
          (click)="login()"
          title="Entrar"
        >
          <ng-container *ngIf="!loging">
            {{ 'ENTRAR' | translate }}
          </ng-container>
        </a>
      </div>
    </div>
  </div>
</div>
